export enum ShippingInsurance {
  DISABLED = "disabled",
  ENABLED = "enabled",
}
